import React from "react";

function SingleTeamCard(props) {
  return (
    <>
      <div className="single-team">
        <div className="member-img">
          <img src={`${process.env.PUBLIC_URL} ${props.image}`} alt="Images" />
          <ul className="team-social">
            <li>
              <a href="https://www.instagram.com/">
                <i className="fab fa-instagram" />
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/">
                <i className="fab fa-facebook-f" />
              </a>
            </li>
            <li>
              <a href="https://www.twitter.com/">
                <i className="fab fa-twitter" />
              </a>
            </li>
            <li>
              <a href="https://www.whatsapp.com/">
                <i className="fab fa-whatsapp" />
              </a>
            </li>
          </ul>
        </div>
        <div className="team-inner">
          <h4>{props.name}</h4>
          <span>{props.title}</span>
        </div>
      </div>
    </>
  );
}

export default SingleTeamCard;
